import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';


const AssessmentComplete = ({ assessmentData, onRestart }) => {
const navigate = useNavigate();
const [modal, setModal] = useState(false);

const handleViewReport = () => {
// navigate('report');
};


const showSystemUpdateModal =()=>{
window.dispatchEvent(
new CustomEvent('openSystemUpgradeModal', {
detail: {
message: 'Scheduled maintenance tonight at 23:00 UTC.'
}
})
);
}


const handleGoToDashboard = () => {
navigate('/');
};

const getCompletionStats = () => {
const stats = {
skillsCount: assessmentData?.skills?.length || 0,
goalsCount: assessmentData?.goals?.length || 0,
experienceCount: assessmentData?.experiences?.length || 0,
benefitsCount: assessmentData?.benefits?.length || 0
};

const totalResponses = stats?.skillsCount + stats?.goalsCount + stats?.experienceCount + stats?.benefitsCount;
return { ...stats, totalResponses };
};

const stats = getCompletionStats();

return (
<div className="bg-card border border-border rounded-lg p-8 text-center">
{/* Success Icon */}
<div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-6">
<Icon name="CheckCircle" size={40} className="text-success" />
</div>
{/* Completion Message */}
<h3 className="text-2xl font-bold text-text-primary mb-4">
Assessment Complete! 🎉
</h3>
<p className="text-text-secondary mb-8 max-w-md mx-auto">
Congratulations! You've successfully completed your career assessment. 
We're now processing your responses to generate personalized career insights and job recommendations.
</p>
{/* Assessment Summary */}
<div className="bg-muted rounded-lg p-6 mb-8">
<h4 className="text-lg font-semibold text-text-primary mb-4">Your Assessment Summary</h4>
<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
<div className="text-center">
<div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-2">
<Icon name="Target" size={24} className="text-primary" />
</div>
<p className="text-2xl font-bold text-text-primary">{stats?.skillsCount}</p>
<p className="text-sm text-text-secondary">Skills Rated</p>
</div>
<div className="text-center">
<div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center mx-auto mb-2">
<Icon name="Flag" size={24} className="text-accent" />
</div>
<p className="text-2xl font-bold text-text-primary">{stats?.goalsCount}</p>
<p className="text-sm text-text-secondary">Goals Set</p>
</div>
<div className="text-center">
<div className="w-12 h-12 bg-warning/10 rounded-lg flex items-center justify-center mx-auto mb-2">
<Icon name="Briefcase" size={24} className="text-warning" />
</div>
<p className="text-2xl font-bold text-text-primary">{stats?.experienceCount}</p>
<p className="text-sm text-text-secondary">Experiences</p>
</div>
<div className="text-center">
<div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center mx-auto mb-2">
<Icon name="Heart" size={24} className="text-secondary" />
</div>
<p className="text-2xl font-bold text-text-primary">{stats?.benefitsCount}</p>
<p className="text-sm text-text-secondary">Benefits Selected</p>
</div>
</div>
</div>
{/* What's Next */}
<div className="bg-primary/5 border border-primary/20 rounded-lg p-6 mb-8">
<h4 className="text-lg font-semibold text-text-primary mb-3">What's Next?</h4>
<div className="space-y-3 text-left">
<div className="flex items-start space-x-3">
<Icon name="FileText" size={20} className="text-primary flex-shrink-0 mt-0.5" />
<div>
<p className="font-medium text-text-primary">Career Report Generation</p>
<p className="text-sm text-text-secondary">We're creating your personalized career report with job recommendations</p>
</div>
</div>
<div className="flex items-start space-x-3">
<Icon name="Search" size={20} className="text-primary flex-shrink-0 mt-0.5" />
<div>
<p className="font-medium text-text-primary">Job Matching</p>
<p className="text-sm text-text-secondary">Our AI will start matching you with relevant job opportunities</p>
</div>
</div>
<div className="flex items-start space-x-3">
<Icon name="Bell" size={20} className="text-primary flex-shrink-0 mt-0.5" />
<div>
<p className="font-medium text-text-primary">Notifications</p>
<p className="text-sm text-text-secondary">You'll receive alerts for new matches and opportunities</p>
</div>
</div>
</div>
</div>
{/* Action Buttons */}
<div className="flex flex-col sm:flex-row gap-4 justify-center">
<Button
onClick={showSystemUpdateModal}
size="lg"
iconName="FileText"
iconPosition="left"
className="min-w-48"
>
View Career Report
</Button>
<Button
variant="outline"
onClick={handleGoToDashboard}
size="lg"
iconName="Home"
iconPosition="left"
className="min-w-48"
>
Go to Dashboard
</Button>
</div>
{/* Additional Actions */}
<div className="mt-8 pt-6 border-t border-border">
<p className="text-sm text-text-secondary mb-4">
Want to update your responses or retake the assessment?
</p>
<Button
variant="ghost"
onClick={onRestart}
size="sm"
iconName="RotateCcw"
iconPosition="left"
>
Retake Assessment
</Button>
</div>
{/* Processing Note */}
<div className="mt-6 p-4 bg-muted rounded-lg">
<div className="flex items-center justify-center space-x-2 text-sm text-text-secondary">
<Icon name="Clock" size={16} />
<span>Report generation typically takes 2-3 minutes</span>
</div>
</div>
</div>
);
};

export default AssessmentComplete;